import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import {
  Footer, MainNavbar, Sidebar,
} from 'components';
import SettingsActions from 'store/reducers/Settings';
import AccountActions from 'store/reducers/Account';
import UserActions from 'store/reducers/User';
import { privateRoutes } from 'config/Routes';
import Container from 'reactstrap/es/Container';
import { handlePromise, isCustomerAdmin } from 'utils';
import UserService from 'api/User';
import AccountService from 'api/Account';
import Crm from 'containers/Crm';

class Private extends React.Component {
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const { sidebarCollapsed } = this.props;

    if ( sidebarCollapsed ) {
      document.body.classList.remove( 'g-sidenav-pinned' );
      document.body.classList.remove( 'g-sidenav-show' );
      document.body.classList.add( 'g-sidenav-hidden' );
    }
  }

  componentDidMount() {
    this.getUserData();
  }

  componentDidUpdate( prevProps ) {
    if ( prevProps.history.pathname !== prevProps.location.pathname ) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.mainContent.scrollTop = 0;
    }
  }

  getUserData = async () => {
    const { updateAccountInfo, updateUser, switchLanguage } = this.props;
    const [, response, responseData] = await handlePromise( AccountService.getMyAccount() );
    if ( response.ok ) {
      updateAccountInfo( responseData );
    }

    const [, userResponse, userResponseData] = await handlePromise( UserService.getUser() );
    if ( userResponse.ok ) {
      // delete userResponseData.language;
      updateUser( userResponseData );

      // switchLanguage({
      //   locale: userResponseData.language,
      //   name: userResponseData.language==="en"?"english":"spanish",
      // });
    }
  };

  getRoutes = ( routes ) => routes.map( ( prop ) => {
    if ( prop.views ) {
      return this.getRoutes( prop.views );
    }
    if ( prop.component ) {
      return (
        <Route
          exact={prop.exact}
          path={prop.layout + prop.path}
          component={prop.component}
          key={prop.layout + prop.path}
        />
      );
    }
    return null;
  } );

  toggleSidenav = () => {
    const { sidebarCollapsed, toggleSidebar } = this.props;
    if ( sidebarCollapsed ) {
      toggleSidebar();
      document.body.classList.add( 'g-sidenav-pinned' );
      document.body.classList.remove( 'g-sidenav-hidden' );
    } else {
      toggleSidebar();
      document.body.classList.remove( 'g-sidenav-pinned' );
      document.body.classList.add( 'g-sidenav-hidden' );
    }
  };

  render() {
    const { history, sidebarCollapsed, userRoles } = this.props;
    const filters = isCustomerAdmin( userRoles )
      ? ( item ) => item.sidebar : ( item ) => !item.admin && item.sidebar;
    const links = _.filter( privateRoutes, filters );
    return (
      <>
        <Sidebar
          routes={privateRoutes}
          toggleSidenav={this.toggleSidenav}
          sidebarCollapsed={sidebarCollapsed}
        />

        <Container className="container-wrapper">
          <MainNavbar
            routes={privateRoutes}
            toggleSidenav={this.toggleSidenav}
            sidebarCollapsed={sidebarCollapsed}
            pathname={history.location.pathname}
          />

          <div
            className="main-content main-content-wrapper"
            ref={( el ) => { this.mainContent = el; }}
            onClick={this.closeSidenav}
          >
            <Switch>
              <Route
                path="/crm/integration"
                component={Crm}
              />
              {this.getRoutes( links )}
              <Redirect from="*" to="/out/new-campaign" />
            </Switch>
            <Footer />
          </div>
        </Container>
        {!sidebarCollapsed ? (
          <div className="backdrop d-xl-none" onClick={this.toggleSidenav} />
        ) : null}
      </>
    );
  }
}

const mapStateToProps = ( { settings, user } ) => ( {
  sidebarCollapsed: settings.sidebarCollapsed,
  userRoles: user.roles,
} );

const mapDispatchToProps = ( {
  toggleSidebar: SettingsActions.toggleSidebar,
  updateAccountInfo: AccountActions.updateInfo,
  updateUser: UserActions.updateUser,
  switchLanguage: SettingsActions.switchLanguage,
} );

export default connect( mapStateToProps, mapDispatchToProps )( Private );
